import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index.vue'
import Chengji from '@/pages/chengji.vue'
import VideoList from '@/pages/videoList.vue'

Vue.use(Router)

const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//解决vue路由重复导航错误
//获取原型对象上的push函数

export default new Router({
  // mode:'hash',
  mode:'history',
  routes: [{
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/chengji',
      name: 'Chengji',
      component: Chengji
    },
    {
      path: '/videolist',
      name: 'Videolist',
      component: VideoList
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js